import { NgModule } from '@angular/core';

import { HisUiService, HisGenericValueService, HisConfirmationService } from 'hisng';

import { ResearchPartnerService } from 'app/fs/res/common/service/researchPartner/researchPartner.service';

import { PublicationService } from '../publication/service/publication.service';
import { OrganizationService } from 'app/fs/res/common/service/organization/organization.service';
import { ResearchInfrastructureService } from './service/research-infrastructure.service';
import { ResearchInfrastructureSharedModule } from './research-infrastructure-shared.module';
import { ResearchInfrastructureRoutesModule } from './research-infrastructure.routes';


@NgModule( {
    imports: [
        ResearchInfrastructureSharedModule,
        ResearchInfrastructureRoutesModule
    ],

    exports: [
        ResearchInfrastructureSharedModule
    ],

    providers: [
        HisGenericValueService,
        HisConfirmationService,
        HisUiService,
        PublicationService,
        ResearchInfrastructureService,
        ResearchPartnerService,
        OrganizationService
    ]
} )

export class ResearchInfrastructureCoreModule {
}
